var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_4906_53615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66972 9.08578C6.82292 9.08578 8.56844 7.34026 8.56844 5.18705C8.56844 3.03385 6.82292 1.28833 4.66972 1.28833C2.51651 1.28833 0.770996 3.03385 0.770996 5.18705C0.770996 7.34026 2.51651 9.08578 4.66972 9.08578Z",
    stroke: "#E02D3C",
    strokeWidth: 1.16962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66992 7.13623H4.67382",
    stroke: "#E02D3C",
    strokeWidth: 1.16962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.53516 4.01733C3.62682 3.75677 3.80774 3.53705 4.04587 3.39709C4.28401 3.25714 4.56399 3.20598 4.83623 3.25268C5.10847 3.29937 5.3554 3.44091 5.53328 3.65222C5.71116 3.86354 5.80852 4.13099 5.80811 4.4072C5.80811 5.18695 4.63849 5.57682 4.63849 5.57682",
    stroke: "#E02D3C",
    strokeWidth: 1.16962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4906_53615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.35693,
    height: 9.35693,
    fill: "white",
    transform: "translate(-0.00878906 0.508545)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionLogo);
export default __webpack_public_path__ + "static/media/question-logo.2954f842ab483b224c7a9f9438bb725a.svg";
export { ForwardRef as ReactComponent };